import { useCallback } from 'react';

import { toast } from 'pixel-react';

const humanizeSection = (sectionType: string) =>
  sectionType.charAt(0).toUpperCase() +
  sectionType.slice(1).replace(/([A-Z])/g, ' $1');

export const useLockToast = () =>
  useCallback(
    (
      _projectId: string,
      sectionType: string,
      message?: string,
      userName?: string,
      lockType?: 'import' | 'revert',
    ) => {
      const importedBy = userName ? ` started by ${userName}` : '';
      const fallback =
        lockType === 'revert'
          ? `${humanizeSection(sectionType)} are being restored by reverting an import${importedBy}.`
          : `${humanizeSection(sectionType)} are being updated by an import ${importedBy}.`;
      toast.info(message || fallback);
    },
    [],
  );
